/**
 * 번역/자막 도메인 타입 및 상수
 *
 * translationSlice.ts에서 추출한 공유 타입과 상수들.
 * 컴포넌트, 훅, 슬라이스 등 여러 곳에서 참조한다.
 */

// ─── 타입 ──────────────────────────────────────────────────────────────────

export type TranslationLanguage = 'ko' | 'en' | 'ja';

export const FONT_SIZE_OPTIONS = [50, 100, 120, 150, 200] as const;
export type FontSizeOption = (typeof FONT_SIZE_OPTIONS)[number];

export type SystemMessageType =
  | 'caption_started'
  | 'caption_ended'
  | 'translation_started'
  | 'translation_ended';

export interface SystemMessage {
  id: string;
  type: SystemMessageType;
  timestamp: number;
}

export interface TranslatingUser {
  enabled: boolean;
  language: TranslationLanguage;
}

// ─── 상수 ──────────────────────────────────────────────────────────────────

/** 크레딧 최소 임계값 — 이 값 미만이면 번역 사용 불가 */
export const CREDIT_THRESHOLD = 500;

export const TRANSLATION_LANGUAGES: { code: TranslationLanguage; label: string }[] = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: '영어' },
  { code: 'ja', label: '일본어' },
];

/** 언어 코드 → 국기 이미지 경로 매핑 */
export const LANGUAGE_FLAG_MAP: Record<TranslationLanguage, string> = {
  ko: 'https://static.wehago.com/imgs/rtc/rtc_nt_kor.png',
  en: 'https://static.wehago.com/imgs/rtc/rtc_nt_usa.png',
  ja: 'https://static.wehago.com/imgs/rtc/rtc_nt_jap.png',
};

/** 언어 코드 → Web Speech API locale 매핑 */
export const LANGUAGE_LOCALE_MAP: Record<TranslationLanguage, string> = {
  ko: 'ko-KR',
  en: 'en-US',
  ja: 'ja-JP',
};
